import React, { useState } from 'react';
import { Mail, Send, MessageCircle, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';
import api from '../services/api';

const Contacto = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);

  const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: 'Completa los campos', description: 'Por favor ingresa tu nombre, correo y mensaje.' });
      return;
    }
    setSending(true);
    try {
      await api.post('/contact', form);
      setForm({ name: '', email: '', message: '' });
      toast({ title: 'Mensaje enviado', description: 'Gracias por contactarnos. Te responderemos pronto.' });
    } catch (err) {
      toast({ title: 'Error al enviar', description: err?.response?.data?.detail || 'Intenta de nuevo.' });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 bg-gradient-to-r from-[#e9f7e4] to-[#f1faeb] px-8 py-8">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-700/10 text-emerald-700">
              <MessageCircle className="h-6 w-6" />
            </span>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900">Contáctanos</h1>
          </div>
          <p className="mt-3 text-slate-600">
            ¿Tienes alguna pregunta? Envíanos un mensaje y te responderemos lo antes posible.
          </p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5 px-8 py-8">
          <div className="grid gap-5 sm:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="name" className="text-slate-700">Nombre</Label>
              <Input id="name" name="name" value={form.name} onChange={onChange} placeholder="Tu nombre" className="h-11 border-slate-200 focus-visible:ring-emerald-500" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-700">Correo Electrónico</Label>
              <div className="relative">
                <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                <Input id="email" name="email" type="email" value={form.email} onChange={onChange} placeholder="tucorreo@ejemplo.com" className="h-11 border-slate-200 pl-10 focus-visible:ring-emerald-500" />
              </div>
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="message" className="text-slate-700">Mensaje</Label>
            <Textarea id="message" name="message" value={form.message} onChange={onChange} placeholder="Escribe tu mensaje..." rows={6} className="border-slate-200 focus-visible:ring-emerald-500" />
          </div>
          <div className="flex justify-end">
            <Button type="submit" disabled={sending} className="h-11 gap-2 bg-emerald-700 px-6 text-white hover:bg-emerald-800">
              {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
              {sending ? 'Enviando...' : 'Enviar Mensaje'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contacto;
